import { z } from "zod";

const safeUrl = z
	.url({ message: "Please enter a valid URL" })
	.refine((value) => !/^javascript:/i.test(value) && !/^data:/i.test(value), { message: "Invalid URL scheme" });

export const updateCommunityLinkSchema = z
	.object({
		title: z.string().trim().min(1).max(80).optional(),
		url: safeUrl.optional(),
	})
	.strict();

export type UpdateCommunityLinkPayload = z.infer<typeof updateCommunityLinkSchema>;
